import { Component, Output, EventEmitter, Input } from '@angular/core';

export interface DialogComplexTextContent {
  title: string;
  titleId?: string;
  confirmButton?: string;
  confirmButtonId?: string;
  cancelButton?: string;
  cancelButtonId?: string;
}

@Component({
  selector: 'app-dialog-complex',
  templateUrl: './dialog-complex.component.html',
  styleUrls: ['./dialog-complex.component.scss'],
  standalone: false
})
export class DialogComplexComponent {
  @Input()
  textContent: DialogComplexTextContent;

  @Input()
  hasCloseButton = true;

  @Output()
  close: EventEmitter<void> = new EventEmitter();

  @Output()
  confirm: EventEmitter<void> = new EventEmitter();
}
